import "./wizard.less";

import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import * as React from "react";

import {useOnMountEffect} from "@khanacademy/wonder-blocks-core";
import {usePublishAnalyticsEvent} from "@khan/analytics-learning-time";

type Props = {
    kaLocale: string;
    countryCode: string;
    product: "teacher-tools" | "grassroots";
};

export default function IneligibleCountry(props: Props): React.ReactElement {
    const publishAnalyticsEvent = usePublishAnalyticsEvent();
    const {kaLocale, countryCode, product} = props;
    useOnMountEffect(() => {
        publishAnalyticsEvent({
            eventType: "KhanLabsIneligibleCountryPageViewed",
            eventSchemaVersion: 2,
            kaLocale: kaLocale,
            countryCode: countryCode,
        });
    });

    const bodyCopy = () => {
        if (product === "teacher-tools") {
            return (
                <Trans>
                    Khanmigo is not yet available in your region.{" "}
                    <a
                        href="https://blog.khanacademy.org/khanmigo-teachers-world-signup/"
                        target="_blank"
                    >
                        Sign up to get notified
                    </a>{" "}
                    when Khanmigo for Teachers is available in your country.
                </Trans>
            );
        }

        return t`Khanmigo is not yet available in your region.`;
    };

    return (
        <div className="wizard-view">
            <div className="container">
                <h1 className="sad-path-heading">
                    {t`Your country isn’t eligible right now.`}
                </h1>
                <p>{bodyCopy()}</p>
            </div>
        </div>
    );
}
